import moment from 'moment';
import { DesktopFilters } from './desktop-filters';
import { MobileFilters } from './mobile-filters';
import { DateFilterOptions } from './util';

export function translateDate(dateFilter: string): { startDate: string; endDate: string } {
	let startDate;
	let endDate;
	const today = moment();

	switch (dateFilter) {
		case DateFilterOptions.TODAY:
			{
				startDate = '@today';
				endDate = '@today';
			}
			break;
		case DateFilterOptions.THIS_WEEK:
			{
				startDate = '@startOfWeek';
				endDate = '@endOfWeek';
			}
			break;
		case DateFilterOptions.NEXT_WEEK:
			{
				startDate = moment(today.add(1, 'weeks').startOf('week')).utc().toISOString();
				endDate = moment(today).endOf('week').utc().toISOString();
			}
			break;
		case DateFilterOptions.LAST_WEEK:
			{
				startDate = moment(today.subtract(1, 'weeks').startOf('week')).utc().toISOString();
				endDate = moment(today.endOf('week')).utc().toISOString();
			}
			break;
		case DateFilterOptions.ALL_PAST:
			{
				endDate = moment(today.subtract(1, 'days')).utc().toISOString();
			}
			break;
		case DateFilterOptions.ALL_UPCOMING:
			{
				startDate = '@today';
			}
			break;
		case DateFilterOptions.ALL_EVENTS:
			break;
	}

	return {
		startDate,
		endDate
	};
}

export function EventFilters({ isMobile }: { isMobile: boolean }) {
	return <div>{isMobile ? <MobileFilters /> : <DesktopFilters />}</div>;
}
